/* ============================================================
   Herfeh Palestine — theme behaviours
   Vanilla JS, no dependencies. Global helpers are invoked from
   section markup (inline handlers) and progressive-enhancement init.
   ============================================================ */
(function () {
  "use strict";

  /* Scroll lock for the drawer.
     `overflow: hidden` on <html> was tried here and does not hold: with the
     drawer open the page still scrolled (measured 600 -> 1400) and stayed where
     it landed after closing, so the visitor was dropped somewhere they never
     chose. Mobile Safari ignores overflow on html/body for this purpose too.

     Pinning the body and offsetting it by the current scroll position is the
     technique that actually works. The offset has to be restored on close,
     otherwise the page snaps to the top — which is why the value is held here
     rather than re-read, and why the restore is explicitly instant (the theme
     sets scroll-behavior: smooth globally, which would animate the restore). */
  var lockedY = 0;
  function lockScroll(on) {
    var body = document.body;
    if (on) {
      if (body.classList.contains('nav-open')) return;
      lockedY = window.pageYOffset || document.documentElement.scrollTop || 0;
      body.style.top = (-lockedY) + 'px';
      body.classList.add('nav-open');
    } else if (body.classList.contains('nav-open')) {
      body.classList.remove('nav-open');
      body.style.top = '';
      /* While the body is pinned it is out of flow, so the document has no
         scrollable height. Un-pinning and scrolling in the same tick restores
         to 0, because the browser clamps against the height it still has —
         which drops the visitor at the top of the page every time they close
         the menu. Reading offsetHeight forces the reflow first, so the scroll
         position it clamps against is the real one. */
      void body.offsetHeight;
      window.scrollTo({ top: lockedY, left: 0, behavior: 'instant' });
    }
  }

  /* Mobile navigation drawer + scrim.
     The closed drawer is only translated off-screen, so without `inert` its ~35
     links stay in the tab order and keyboard users land on invisible controls.
     Focus moves to the close button on open and back to the toggle on close. */
  window.HerfehMobile = function (open) {
    var nav = document.getElementById('mnav');
    var scrim = document.querySelector('.scrim');
    var toggle = document.querySelector('.mobile-toggle[aria-controls="mnav"]');
    var hadFocusInside = nav ? nav.contains(document.activeElement) : false;
    if (nav) {
      nav.classList.toggle('open', open);
      nav.inert = !open;
    }
    if (scrim) scrim.classList.toggle('open', open);
    if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    lockScroll(open);

    if (open) {
      var closeBtn = nav && nav.querySelector('.mnav-close');
      if (closeBtn) closeBtn.focus();
    } else if (hadFocusInside && toggle) {
      toggle.focus();
    }
  };

  /* Close the drawer when the viewport leaves the mobile breakpoint.
     Without this, rotating a phone to landscape with the menu open is a
     dead end. At 1000px and up base.css hides the drawer, the scrim AND the
     hamburger, but the body stays pinned by lockScroll — so the page is
     frozen at its stored offset and every control that could call
     HerfehMobile(false) has no layout box. Measured at 844x390: scroll
     dead, all four controls unhittable, reload the only escape.

     Keyed to the media query rather than a resize handler, so it fires
     exactly once on the crossing instead of on every resize frame — and
     it fires for a window drag on desktop too, not just rotation. */
  if (window.matchMedia) {
    var mobileMQ = window.matchMedia('(max-width: 999.98px)');   /* base.css header layer */
    var leaveMobile = function (e) {
      if (!e.matches && document.body.classList.contains('nav-open')) {
        window.HerfehMobile(false);
      }
    };
    if (mobileMQ.addEventListener) mobileMQ.addEventListener('change', leaveMobile);
    else if (mobileMQ.addListener) mobileMQ.addListener(leaveMobile);   /* Safari < 14 */
  }

  /* Shop mega-menu: click the Shop button to toggle it open (no hover) */
  function closeMegas(except) {
    var open = document.querySelectorAll('.has-mega.open');
    for (var i = 0; i < open.length; i++) {
      if (open[i] === except) continue;
      open[i].classList.remove('open');
      var b = open[i].querySelector('button[aria-haspopup]');
      if (b) b.setAttribute('aria-expanded', 'false');
    }
  }
  window.HerfehShopMenu = function (btn) {
    var wrap = btn.closest('.has-mega');
    if (!wrap) return;
    closeMegas(wrap);
    var isOpen = wrap.classList.toggle('open');
    btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  };
  /* Dismiss on outside click */
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.has-mega')) closeMegas(null);
  });
  /* Dismiss on Escape, returning focus to the trigger */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;

    /* Mobile drawer first — it is the topmost layer when open. */
    var drawer = document.getElementById('mnav');
    if (drawer && drawer.classList.contains('open')) {
      window.HerfehMobile(false);
      return;
    }

    var open = document.querySelector('.has-mega.open');
    if (!open) return;
    var b = open.querySelector('button[aria-haspopup]');
    closeMegas(null);
    if (b) b.focus();
  });

  /* Product quantity stepper */
  /* The ceiling is whatever Shopify says is in stock, and 0 means "no real
     limit" — inventory untracked, or the policy is `continue`, in which case we
     do not invent a cap. Read from the DOM every time rather than cached at load,
     because the variant picker rewrites it when the selection changes. */
  function qtyMax(input) {
    var max = parseInt(input.getAttribute('data-qty-max'), 10);
    return max > 0 ? max : 0;
  }

  /* A "+" that does nothing is worse than one that is visibly spent. At the
     ceiling it is marked spent (faded, aria-disabled) but NOT `disabled`
     (2026-10-20): a disabled button swallows the tap silently, which is what
     Clarity caught shoppers doing in the cart. Kept live, a tap on it nudges the
     stock note underneath, so the shopper sees why nothing changed. The note
     itself follows the selected variant's cap: "One of a kind" for 1 in stock,
     "Only N available" at a larger cap, nothing when there is no cap. */
  var EASE_QTY = 'cubic-bezier(.2,.7,.2,1)';
  var qtyReady = false;

  function qtyAnnounce(text) {
    var live = document.querySelector('[data-qty-live]');
    if (!live) return;
    live.textContent = '';
    setTimeout(function () { live.textContent = text; }, 60);
  }

  function syncQtyNote(input) {
    var n = document.querySelector('[data-qty-note]');
    if (!n) return;
    var max = qtyMax(input);
    var show = max === 1 || (max > 1 && (parseInt(input.value, 10) || 1) >= max);
    var text = max === 1 ? n.getAttribute('data-one')
      : max > 1 ? (n.getAttribute('data-only') || '').replace('__N__', max) : '';
    if (n.textContent !== text) n.textContent = text;
    if (n.hidden === !show) return;
    n.hidden = !show;
    if (show && qtyReady) {
      var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!calm && n.animate) n.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 260, easing: EASE_QTY });
      qtyAnnounce(text);
    }
  }

  /* Same pulse as the cart's spent "+": a warm flash to the accent and back,
     with a soft "can't" nudge (colour only under reduced motion). EASE on each
     leg, not the whole run, so the peak lands mid-animation. Earlier runs are
     cancelled so rapid taps never stack; fill 'none' hands the resting look
     back to the stylesheet. Kept separate from the cart's copy on purpose: the
     cart section is live and is not touched by this change. */
  function nudgeQtyNote() {
    var n = document.querySelector('[data-qty-note]');
    if (!n || !n.textContent) return;
    if (n.hidden) n.hidden = false;
    (n._nudge || []).forEach(function (a) { a.cancel(); });
    n._nudge = [];
    if (n.animate) {
      var rest = getComputedStyle(n).color;
      var hot = getComputedStyle(document.documentElement).getPropertyValue('--orange').trim() || rest;
      var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      n._nudge.push(n.animate([{ color: rest, easing: EASE_QTY }, { color: hot, offset: .3, easing: EASE_QTY }, { color: rest }], { duration: 650, fill: 'none' }));
      if (!calm) n._nudge.push(n.animate([
        { transform: 'translateX(0)', easing: EASE_QTY }, { transform: 'translateX(-3px)', easing: EASE_QTY }, { transform: 'translateX(3px)', easing: EASE_QTY },
        { transform: 'translateX(-1.5px)', easing: EASE_QTY }, { transform: 'translateX(0)' }
      ], { duration: 360, fill: 'none' }));
    }
    qtyAnnounce(n.textContent.trim());
  }

  function syncQtyUp(input) {
    var up = document.querySelector('[data-qty-up]');
    if (!up) return;
    var max = qtyMax(input);
    var at = max > 0 && (parseInt(input.value, 10) || 1) >= max;
    up.disabled = false;
    up.classList.toggle('is-max', at);
    up.setAttribute('aria-disabled', at ? 'true' : 'false');
    syncQtyNote(input);
  }

  window.HerfehQty = function (delta) {
    var input = document.getElementById('qty');
    if (!input) return;
    var max = qtyMax(input);
    var now = parseInt(input.value, 10) || 1;
    var next = now + delta;
    if (next < 1) next = 1;
    if (max > 0 && next > max) next = max;
    input.value = next;
    syncQtyUp(input);
    if (delta > 0 && max > 0 && next === now) nudgeQtyNote();
  };

  /* Typing bypasses the buttons entirely, so the same clamp has to run on the
     input itself. Clamping on `change` rather than `input` lets someone delete
     the field and retype without it fighting them mid-keystroke. */
  function initQtyClamp() {
    var input = document.getElementById('qty');
    if (!input) return;
    input.addEventListener('change', function () {
      var max = qtyMax(input);
      var v = parseInt(input.value, 10);
      if (!v || v < 1) v = 1;
      if (max > 0 && v > max) v = max;
      input.value = v;
      syncQtyUp(input);
    });
    syncQtyUp(input);
    qtyReady = true;
  }

  /* Product gallery thumbnail swap — delegated, reads data-full off the thumb.
     Inline handlers cannot be used here: image_tag strips unknown attributes.

     Speed (2026-10-22): each full photo used to be fetched only on the click,
     so the old photo sat there for 0.7 to 1.2s with nothing happening. Now the
     full files are warmed one at a time once the main photo is in (skipped
     under Save-Data), and a hover or press on a thumb warms that one first. A
     click on a photo that is ready swaps at once; one still loading shows the
     thumb's own small file straight away, softened, and sharpens when the full
     file has decoded. Only the last click wins if several come quickly. */
  function initGallery() {
    var thumbs = document.querySelector('[data-gallery-thumbs]');
    if (!thumbs) return;
    var main = document.getElementById('pdp-main');
    var cache = {}, want = '';

    function warm(url) {
      if (!url) return null;
      if (!cache[url]) {
        var im = new Image();
        im.decoding = 'async';
        im.src = url;
        cache[url] = im;
      }
      return cache[url];
    }
    function ready(im) { return im && im.complete && im.naturalWidth > 0; }

    function show(thumb) {
      var url = thumb.getAttribute('data-full');
      if (!main || !url) return;
      want = url;
      var im = warm(url);
      main.removeAttribute('srcset');
      /* A sharpened zoom file belongs to the old photo; let the zoom fetch it
         again for this one. */
      main.removeAttribute('data-pz-sharp');
      if (ready(im)) {
        main.src = url;
        main.classList.remove('is-loading');
        return;
      }
      main.src = thumb.currentSrc || thumb.src;
      main.classList.add('is-loading');
      var done = function () {
        /* Skip if another thumb was clicked since, or the zoom has already
           swapped in its sharper file for this photo. */
        if (want !== url || main.hasAttribute('data-pz-sharp')) return;
        main.src = url;
        main.classList.remove('is-loading');
      };
      if (im.decode) im.decode().then(done, done);
      else { im.addEventListener('load', done); im.addEventListener('error', done); }
    }

    thumbs.addEventListener('click', function (e) {
      var thumb = e.target.closest('img[data-full]');
      if (!thumb || !thumbs.contains(thumb)) return;
      show(thumb);
      var all = thumbs.querySelectorAll('img');
      for (var i = 0; i < all.length; i++) all[i].classList.remove('active');
      thumb.classList.add('active');
    });
    var early = function (e) {
      var thumb = e.target.closest && e.target.closest('img[data-full]');
      if (thumb) warm(thumb.getAttribute('data-full'));
    };
    thumbs.addEventListener('pointerover', early);
    thumbs.addEventListener('pointerdown', early);

    var conn = navigator.connection;
    if (conn && conn.saveData) return;
    function warmAll() {
      var list = thumbs.querySelectorAll('img[data-full]'), i = 0;
      (function next() {
        if (i >= list.length) return;
        var im = warm(list[i++].getAttribute('data-full'));
        if (ready(im)) { next(); return; }
        im.addEventListener('load', next);
        im.addEventListener('error', next);
      })();
    }
    /* Start once the main photo is in, not on window load: third-party
       scripts held load back to about 13s on slow mobile data. */
    var idle = function (fn) {
      if (window.requestIdleCallback) requestIdleCallback(fn, { timeout: 1500 });
      else setTimeout(fn, 600);
    };
    if (!main || main.complete) idle(warmAll);
    else main.addEventListener('load', function () { idle(warmAll); }, { once: true });
  }

  /* Main product photo: click or tap to zoom in place (2026-10-22).
     Clarity showed shoppers tapping the photo expecting it to grow. It now
     zooms inside its own frame (.main clips), so nothing covers the page.

     The img is drawn as translate(t) scale(S) from origin 0 0, and t is always
     kept within [-(S-1) * frame, 0] so an edge of the photo never comes inside
     the frame. Mouse: the point under the cursor stays under the cursor
     (t = -(S-1) * p), so moving across the frame sweeps the whole photo, like a
     magnifier. Touch: the first tap zooms on that point, then a drag moves the
     photo with the finger, and touch-action: none (CSS, zoomed only) keeps the
     page from scrolling meanwhile. A second click or tap, Esc, the cursor
     leaving the frame, or a thumb change turn it off.

     Transform only. The ease is a CSS transition switched on just for the zoom
     in and out, so a pointer move mid-ease retargets it rather than jumping;
     reduced motion drops the transition (main-product's CSS). */
  function initPhotoZoom() {
    var btn = document.querySelector('[data-pz]');
    var img = btn && btn.querySelector('img');
    if (!img) return;
    var S = 2.4, on = false, tx = 0, ty = 0;
    var drag = null, dragged = false, easeTimer = 0;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

    function apply(x, y) {
      var w = btn.clientWidth, h = btn.clientHeight;
      tx = Math.min(0, Math.max(-(S - 1) * w, x));
      ty = Math.min(0, Math.max(-(S - 1) * h, y));
      img.style.transform = 'translate3d(' + tx + 'px,' + ty + 'px,0) scale(' + S + ')';
    }
    function local(e) {
      var r = btn.getBoundingClientRect();
      return { x: e.clientX - r.left, y: e.clientY - r.top };
    }
    function ease() {
      clearTimeout(easeTimer);
      if (reduce.matches) { btn.classList.remove('is-easing'); return; }
      btn.classList.add('is-easing');
      easeTimer = setTimeout(function () { btn.classList.remove('is-easing'); }, 240);
    }
    /* The page's own file is at most 1600px; at 2.4x that is soft. The 2048px
       file is fetched on the first zoom of each photo and swapped in once it
       has decoded, so the photo never blanks while it loads. */
    function sharpen() {
      var src = btn.getAttribute('data-pz-src');
      if (!src || img.getAttribute('data-pz-sharp') === src) return;
      img.setAttribute('data-pz-sharp', src);
      var pre = new Image();
      pre.src = src;
      var swap = function () {
        if (btn.getAttribute('data-pz-src') !== src) return;
        img.removeAttribute('srcset');
        img.src = src;
      };
      if (pre.decode) pre.decode().then(swap, function () {});
      else pre.onload = swap;
    }
    function zoomIn(px, py) {
      on = true;
      btn.classList.add('is-zoomed');
      btn.setAttribute('aria-pressed', 'true');
      ease();
      apply(-(S - 1) * px, -(S - 1) * py);
      sharpen();
    }
    function zoomOut(instant) {
      if (!on) return;
      on = false;
      drag = null;
      btn.classList.remove('is-zoomed');
      btn.setAttribute('aria-pressed', 'false');
      if (instant) { clearTimeout(easeTimer); btn.classList.remove('is-easing'); }
      else ease();
      img.style.transform = '';
      tx = 0; ty = 0;
    }

    btn.addEventListener('click', function (e) {
      if (dragged) { dragged = false; return; }
      if (on) { zoomOut(); return; }
      /* detail 0 is a keyboard click (Enter/Space): zoom on the centre. */
      var p = e.detail === 0 ? { x: btn.clientWidth / 2, y: btn.clientHeight / 2 } : local(e);
      zoomIn(p.x, p.y);
    });

    btn.addEventListener('pointerdown', function (e) {
      dragged = false;
      if (!on || e.pointerType !== 'touch') return;
      drag = { id: e.pointerId, x0: e.clientX, y0: e.clientY, tx: tx, ty: ty };
      try { btn.setPointerCapture(e.pointerId); } catch (err) {}
    });
    btn.addEventListener('pointermove', function (e) {
      if (!on) return;
      if (e.pointerType !== 'touch') {
        var p = local(e);
        apply(-(S - 1) * p.x, -(S - 1) * p.y);
        return;
      }
      if (!drag || e.pointerId !== drag.id) return;
      var dx = e.clientX - drag.x0, dy = e.clientY - drag.y0;
      if (!dragged && Math.abs(dx) + Math.abs(dy) > 6) dragged = true;
      if (dragged) apply(drag.tx + dx, drag.ty + dy);
    });
    function endDrag(e) {
      if (drag && e.pointerId === drag.id) drag = null;
    }
    btn.addEventListener('pointerup', endDrag);
    btn.addEventListener('pointercancel', endDrag);
    btn.addEventListener('pointerleave', function (e) {
      if (e.pointerType === 'mouse') zoomOut();
    });
    /* Belt and braces for browsers that start a scroll before touch-action
       applies: a drag inside a zoomed photo never moves the page. */
    btn.addEventListener('touchmove', function (e) {
      if (on && e.cancelable) e.preventDefault();
    }, { passive: false });

    /* Arrow keys look around a zoomed photo; Esc turns it off. */
    btn.addEventListener('keydown', function (e) {
      if (!on) return;
      var step = btn.clientWidth * 0.12;
      var k = { ArrowLeft: [step, 0], ArrowRight: [-step, 0], ArrowUp: [0, step], ArrowDown: [0, -step] }[e.key];
      if (!k) return;
      e.preventDefault();
      ease();
      apply(tx + k[0], ty + k[1]);
    });
    document.addEventListener('keydown', function (e) {
      if (on && e.key === 'Escape') zoomOut();
    });

    /* A new photo from the thumbs: drop the zoom at once (no ease on a photo
       that has just changed) and point the sharp file at the new one. The
       swap handler above has already changed the src by the time this runs. */
    var thumbs = document.querySelector('[data-gallery-thumbs]');
    if (thumbs) {
      thumbs.addEventListener('click', function (e) {
        var thumb = e.target.closest('img[data-zoom]');
        if (!thumb) return;
        zoomOut(true);
        btn.setAttribute('data-pz-src', thumb.getAttribute('data-zoom'));
      });
    }
    /* Only a real width change: a phone's address bar showing or hiding fires
       resize too, and that must not drop the zoom. */
    var lastW = btn.clientWidth;
    window.addEventListener('resize', function () {
      if (btn.clientWidth !== lastW) { lastW = btn.clientWidth; zoomOut(true); }
    });
  }

  /* Product variant picker: maps the selected option values to a variant,
     then updates the hidden id input, the price and the add-to-cart button. */
  function initVariants() {
    var data = document.querySelector('script[type="application/json"][data-product-variants]');
    var idInput = document.getElementById('pdp-variant-id');
    var selects = document.querySelectorAll('select[data-option-index]');
    if (!data || !idInput || !selects.length) return;

    var variants, prices;
    try { variants = JSON.parse(data.textContent); } catch (e) { return; }
    if (!variants || !variants.length) return;

    var stock = null;
    var stockData = document.querySelector('script[type="application/json"][data-variant-stock]');
    if (stockData) {
      try { stock = JSON.parse(stockData.textContent); } catch (e) { stock = null; }
    }

    var priceData = document.querySelector('script[type="application/json"][data-product-prices]');
    if (priceData) {
      try { prices = JSON.parse(priceData.textContent); } catch (e) { prices = null; }
    }

    var priceEl = document.getElementById('pdp-price');
    var addBtn = document.querySelector('[data-add-to-cart]');

    function selectedValues() {
      var values = [];
      for (var i = 0; i < selects.length; i++) {
        var pos = parseInt(selects[i].getAttribute('data-option-index'), 10);
        if (!pos) continue;
        values[pos - 1] = selects[i].value;
      }
      return values;
    }

    function match(values) {
      for (var i = 0; i < variants.length; i++) {
        var opts = variants[i].options || [];
        var ok = opts.length === values.length;
        for (var k = 0; ok && k < values.length; k++) {
          if (opts[k] !== values[k]) ok = false;
        }
        if (ok) return variants[i];
      }
      return null;
    }

    function renderPrice(variant) {
      if (!priceEl || !prices) return;
      var money = prices[String(variant.id)];
      if (!money) return;
      priceEl.textContent = money.price;
      if (money.compare_at_price) {
        var s = document.createElement('s');
        s.textContent = money.compare_at_price;
        priceEl.appendChild(document.createTextNode(' '));
        priceEl.appendChild(s);
      }
    }

    function update() {
      var variant = match(selectedValues());
      if (variant) {
        idInput.value = variant.id;
        renderPrice(variant);

        /* The ceiling belongs to the variant, not the product: picking a colour
           with 1 left must not inherit the previous colour's 40. Re-clamp the
           current value too, or a quantity chosen under the old cap survives the
           switch. */
        var qtyInput = document.getElementById('qty');
        if (qtyInput && stock) {
          var vmax = parseInt(stock[variant.id], 10) || 0;
          if (vmax > 0) {
            qtyInput.setAttribute('data-qty-max', vmax);
            qtyInput.setAttribute('max', vmax);
            if ((parseInt(qtyInput.value, 10) || 1) > vmax) qtyInput.value = vmax;
          } else {
            qtyInput.removeAttribute('data-qty-max');
            qtyInput.removeAttribute('max');
          }
          syncQtyUp(qtyInput);
        }
      }
      if (!addBtn) return;
      var available = !!(variant && variant.available);
      addBtn.disabled = !available;
      var label = available
        ? addBtn.getAttribute('data-label-add')
        : addBtn.getAttribute('data-label-sold-out');
      if (label) addBtn.textContent = label;
    }

    for (var i = 0; i < selects.length; i++) {
      selects[i].addEventListener('change', update);
    }
    update();
  }

  /* Wishlist, persisted in localStorage */
  function readWish() {
    try { return JSON.parse(localStorage.getItem('herfeh_wish') || '[]'); }
    catch (e) { return []; }
  }
  /* Keep the header wishlist icon's count badge in sync with saved items. */
  function updateWishBadge() {
    var n = readWish().length;
    var badges = document.querySelectorAll('[data-wish-count]');
    for (var b = 0; b < badges.length; b++) {
      badges[b].textContent = n;
      badges[b].setAttribute('data-n', n);
      if (n > 0) { badges[b].removeAttribute('hidden'); } else { badges[b].setAttribute('hidden', ''); }
    }
  }
  window.HerfehToggleWish = function (handle) {
    if (!handle) return;
    var wish = readWish();
    var i = wish.indexOf(handle);
    if (i >= 0) { wish.splice(i, 1); } else { wish.push(handle); }
    try { localStorage.setItem('herfeh_wish', JSON.stringify(wish)); } catch (e) {}
    var btns = document.querySelectorAll('[data-wish="' + handle + '"]');
    for (var k = 0; k < btns.length; k++) {
      btns[k].classList.toggle('on', wish.indexOf(handle) >= 0);
    }
    updateWishBadge();
  };

  /* ---- Wishlist page: render the saved products from localStorage ----
     Lives here in theme.js (which loads reliably on every page) rather than in
     the section's {% javascript %} bundle, so the grid always populates. */
  function wlEsc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function wlMoney(cents) {
    var amount = (cents || 0) / 100;
    var code = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || '';
    if (code && window.Intl && Intl.NumberFormat) {
      try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: code }).format(amount); }
      catch (e) {}
    }
    return '$' + amount.toFixed(2);
  }
  function wlSized(url, w) {
    if (!url) return '';
    if (url.indexOf('//') === 0) url = 'https:' + url;
    if (url.indexOf('/cdn/shop') !== -1 || url.indexOf('cdn.shopify') !== -1) {
      return url + (url.indexOf('?') !== -1 ? '&' : '?') + 'width=' + w;
    }
    return url;
  }
  function wlFirstVariant(p) {
    var vs = p.variants || [];
    for (var i = 0; i < vs.length; i++) { if (vs[i].available) return vs[i].id; }
    return vs.length ? vs[0].id : null;
  }
  function wlRefreshCart() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var badges = document.querySelectorAll('.count-badge:not(.wish-badge)');
        for (var i = 0; i < badges.length; i++) {
          badges[i].setAttribute('data-n', c.item_count);
          badges[i].textContent = c.item_count;
        }
      })
      .catch(function () {});
  }
  function wlAddToCart(variantId, btn, cfg) {
    if (!variantId) return;
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function () {
        wlRefreshCart();
        btn.textContent = cfg.addedLabel;
        setTimeout(function () { btn.disabled = false; btn.textContent = cfg.addLabel; }, 1400);
      })
      .catch(function () { btn.disabled = false; });
  }
  function wlFetchProduct(handle) {
    return fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function (p) { return { handle: handle, product: p }; })
      .catch(function () { return null; });
  }
  function wlBuildCard(handle, p, cfg) {
    var url = wlEsc(p.url || ('/products/' + handle));
    var title = wlEsc(p.title);
    var vendor = wlEsc(p.vendor || '');
    var img = wlSized(p.featured_image || (p.images && p.images[0]) || '', 400);
    var priceHtml;
    if (p.compare_at_price && p.compare_at_price > p.price) {
      priceHtml = wlMoney(p.price) +
        ' <s style="color:var(--muted);font-weight:400;margin-inline-start:6px">' + wlMoney(p.compare_at_price) + '</s>';
    } else {
      priceHtml = wlMoney(p.price);
    }
    var vid = wlFirstVariant(p);
    var available = !!p.available && vid != null;
    var media = '<div class="card-media">' +
      '<a class="thumb" href="' + url + '" aria-label="' + title + '">' +
        (img ? '<img src="' + wlEsc(img) + '" alt="' + title + '" loading="lazy" width="400" height="500">' : '') +
      '</a>' +
      '<button class="wish on" type="button" data-remove data-wish="' + wlEsc(handle) + '" aria-label="' + wlEsc(cfg.removeLabel) + '">' +
        '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 20s-7-4.6-7-9.5A3.5 3.5 0 0 1 12 7a3.5 3.5 0 0 1 7 3.5C19 15.4 12 20 12 20Z"/></svg>' +
      '</button>' +
      '<div class="quick">' +
        '<button class="btn btn-primary btn-block js-wish-add" type="button" data-variant="' + (vid || '') + '"' +
          ' style="padding:.62em 1em;font-size:.82rem"' + (available ? '' : ' disabled') + '>' +
          wlEsc(available ? cfg.addLabel : cfg.soldOutLabel) +
        '</button>' +
      '</div>' +
    '</div>';
    return '<div class="card" data-wish-card="' + wlEsc(handle) + '">' +
      media +
      '<a href="' + url + '">' +
        '<div class="vendor">' + vendor + '</div>' +
        '<div class="name">' + title + '</div>' +
      '</a>' +
      '<div class="price">' + priceHtml + '</div>' +
    '</div>';
  }
  function initWishlistPage() {
    var root = document.querySelector('[data-wishlist]');
    if (!root) return;
    var grid = root.querySelector('[data-wish-grid]');
    var empty = root.querySelector('[data-wish-empty]');
    var loading = root.querySelector('[data-wish-loading]');
    if (!grid) return;
    var cfg = {
      addLabel: root.getAttribute('data-add-label') || 'Add to cart',
      addedLabel: root.getAttribute('data-added-label') || 'Added',
      soldOutLabel: root.getAttribute('data-soldout-label') || 'Sold out',
      removeLabel: root.getAttribute('data-remove-label') || 'Remove'
    };
    function hide(el) { if (el) el.setAttribute('hidden', ''); }
    function show(el) { if (el) el.removeAttribute('hidden'); }
    function showEmpty() { hide(loading); show(empty); }
    grid.addEventListener('click', function (e) {
      var removeBtn = e.target.closest ? e.target.closest('[data-remove]') : null;
      if (removeBtn) {
        var h = removeBtn.getAttribute('data-wish');
        if (window.HerfehToggleWish) { window.HerfehToggleWish(h); }
        var card = removeBtn.closest('[data-wish-card]');
        if (card && card.parentNode) { card.parentNode.removeChild(card); }
        if (!grid.querySelector('[data-wish-card]')) { showEmpty(); }
        return;
      }
      var addBtn = e.target.closest ? e.target.closest('.js-wish-add') : null;
      if (addBtn && !addBtn.disabled) {
        wlAddToCart(addBtn.getAttribute('data-variant'), addBtn, cfg);
      }
    });
    var handles = readWish();
    if (!handles.length) { showEmpty(); return; }
    hide(empty); show(loading);
    Promise.all(handles.map(wlFetchProduct)).then(function (results) {
      var html = '';
      var count = 0;
      for (var i = 0; i < results.length; i++) {
        var res = results[i];
        if (!res || !res.product) { continue; } /* skip 404 / deleted products */
        html += wlBuildCard(res.handle, res.product, cfg);
        count++;
      }
      hide(loading);
      if (!count) { showEmpty(); return; }
      grid.innerHTML = html;
    });
  }

  /* Tatreez star-line separators: dock-style magnify. Each .tz-dock is filled
     with individual star tiles; on pointermove every star scales by its distance
     to the cursor (cosine falloff), so the star under the pointer grows most and
     its neighbours taper off. Leaving resets them (CSS transition eases it back).
     Star centres don't move under a centred scale, so distances stay stable. */
  function initSeamDock() {
    var docks = document.querySelectorAll('.tz-dock');
    if (!docks.length) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var STEP = 28, RADIUS = 64;               // slot width and how far the magnify reaches, in px
    var REST = 0.636, PEAK = 1.0;             // rest scale (44px -> 28px) and peak (native 44px, crisp)
    // Colour ramp under the cursor: cream -> brand orange. (Ink was tried but
    // vanishes against the dark ink/brick bands this line sits over.)
    var SAND = [231, 216, 200], ACCENT = [241, 90, 37];

    for (var d = 0; d < docks.length; d++) {
      (function (dock) {
        var stars = [], centres = [];   // centres: each star's x offset from the dock's left edge

        function build() {
          dock.textContent = '';
          stars = [];
          var n = Math.ceil(dock.clientWidth / STEP) + 3;
          for (var i = 0; i < n; i++) {
            var slot = document.createElement('i');
            slot.className = 'tz-slot';
            var star = document.createElement('b');
            star.className = 'tz-star';
            slot.appendChild(star);
            dock.appendChild(slot);
            stars.push(star);
          }
          measure();
        }

        /* Measured once per build, not once per star per frame. The slots are a
           fixed-width flex row and the stars scale about their own centres, so
           these offsets never change while the dock sits still — only the dock's
           own position does, and render() reads that once. The old version called
           getBoundingClientRect() for every star on every frame: ~30 forced
           layouts at 60fps, which is a synchronous reflow ~1800 times a second
           and exactly the kind of thing that makes a smooth idea feel gritty. */
        function measure() {
          var base = dock.getBoundingClientRect().left;
          centres = [];
          for (var i = 0; i < stars.length; i++) {
            var b = stars[i].parentNode.getBoundingClientRect();
            centres.push(b.left + b.width / 2 - base);
          }
        }

        build();

        /* Rebuilding the whole star line on every resize tick means tearing down
           and re-creating ~30 nodes dozens of times during one window drag. */
        var resizeTimer = null;
        window.addEventListener('resize', function () {
          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(build, 150);
        });
        if (reduce) return;

        var raf = null, targetX = null, restTimer = null;

        function render() {
          raf = null;
          var base = dock.getBoundingClientRect().left;   // one layout read per frame, not one per star
          for (var i = 0; i < stars.length; i++) {
            var cx = base + centres[i], t = 0;
            if (targetX != null) {
              var dist = Math.abs(cx - targetX);
              if (dist < RADIUS) t = 0.5 * (1 + Math.cos(Math.PI * dist / RADIUS));
            }
            var s = REST + (PEAK - REST) * t;
            stars[i].style.transform = 'scale(' + s.toFixed(3) + ')';
            var r = Math.round(SAND[0] + (ACCENT[0] - SAND[0]) * t);
            var g = Math.round(SAND[1] + (ACCENT[1] - SAND[1]) * t);
            var bl = Math.round(SAND[2] + (ACCENT[2] - SAND[2]) * t);
            stars[i].style.backgroundColor = 'rgb(' + r + ',' + g + ',' + bl + ')';
          }
        }

        /* .resting swaps the stars onto a slow settle curve (base.css). It is on
           only while they are travelling home, so a cursor that comes back mid-
           settle is tracked immediately instead of queueing behind the animation. */
        dock.addEventListener('pointerenter', function () {
          clearTimeout(restTimer);
          dock.classList.remove('resting');
        }, { passive: true });

        dock.addEventListener('pointermove', function (e) {
          targetX = e.clientX;
          if (!raf) raf = window.requestAnimationFrame(render);
        }, { passive: true });

        dock.addEventListener('pointerleave', function () {
          targetX = null;
          dock.classList.add('resting');
          if (!raf) raf = window.requestAnimationFrame(render);
          clearTimeout(restTimer);
          restTimer = setTimeout(function () { dock.classList.remove('resting'); }, 600);
        }, { passive: true });
      })(docks[d]);
    }
  }

  /* Artisan application: the "Other craft" field. CSS (:has) already shows and
     hides it, so this only keeps the form data honest — the input is disabled
     unless Other is selected, so it never submits alongside a different craft,
     and required only while it is actually visible. Value is kept rather than
     cleared so switching away and back does not lose what was typed. */
  function initCraftOther() {
    var select = document.getElementById('aa-craft');
    var input = document.getElementById('aa-craft-other');
    if (!select || !input) return;

    function sync() {
      var isOther = select.value === 'Other';
      input.disabled = !isOther;   /* disabled fields are not submitted */
      input.required = isOther;
    }

    select.addEventListener('change', sync);
    sync();
  }

  /* Artisan application: usability repairs on the contact form.

     1. The portfolio field is type="url", which rejects "instagram.com/shop"
        with an unhelpful browser message. Applicants are makers, not developers,
        so a missing scheme is normalised to https:// instead of blocking them.
     2. A failed post reloads the page, so focus is moved to the error summary.
        Without it the visitor lands back at the top with no idea what happened.
     3. Shopify only repopulates name, email and body. Everything else (phone,
        craft, location, portfolio) is wiped by a single typo in the email, so
        those are stashed per session and restored only after a failed post. */
  function initArtisanForm() {
    var form = document.querySelector('.aa-form');
    if (!form) return;

    var KEY = 'herfeh_artisan_form';
    var custom = ['aa-phone', 'aa-craft', 'aa-craft-other', 'aa-location', 'aa-portfolio'];

    /* 1. Forgiving URL entry. Tidy up what is unambiguously a bare domain, and
          leave anything else exactly as typed — an "@handle" turned into
          "https://@handle" would be a broken link, and free text is still
          perfectly readable by the person reviewing the application. */
    var portfolio = document.getElementById('aa-portfolio');
    if (portfolio) {
      portfolio.addEventListener('blur', function () {
        var v = portfolio.value.trim();
        portfolio.value = v;
        if (!v) return;
        if (/^https?:\/\//i.test(v)) return;             // already a URL
        if (v.charAt(0) === '@') return;                 // a handle, not a link
        if (/^[\w-]+(\.[\w-]+)+(\/\S*)?$/.test(v)) {     // looks like a bare domain
          portfolio.value = 'https://' + v;
        }
      });
    }

    /* 3a. Keep a copy of the fields Shopify will not give back */
    function stash() {
      var data = {};
      custom.forEach(function (id) {
        var el = document.getElementById(id);
        if (el && el.value) data[id] = el.value;
      });
      try { sessionStorage.setItem(KEY, JSON.stringify(data)); } catch (e) {}
    }
    form.addEventListener('submit', stash);

    /* 3b. Restore, but only when the reload was caused by a failed post */
    var errors = form.querySelector('[data-form-errors]');
    if (errors) {
      var saved = null;
      try { saved = JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch (e) {}
      if (saved) {
        Object.keys(saved).forEach(function (id) {
          var el = document.getElementById(id);
          if (el && !el.value) el.value = saved[id];
        });
        /* The restored craft may be "Other", so let initCraftOther re-sync via
           its own change listener rather than reaching into its scope. */
        var craft = document.getElementById('aa-craft');
        if (craft) craft.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    /* Nothing left to restore once it actually went through */
    var success = form.querySelector('[data-form-success]');
    if (success) {
      try { sessionStorage.removeItem(KEY); } catch (e) {}
      success.focus();
    }
  }

  /* Send focus to a failed submission's explanation, on ANY form that marks one.
     This used to live inside initArtisanForm, which returns early unless it
     finds `.aa-form` — so when the contact form gained the same
     `[data-form-errors]` wrapper, it inherited the styling but silently got no
     focus and no scroll. A visitor whose post failed was left at whatever
     scroll position the reload chose, with the reason possibly off-screen.

     Keyed off the attribute rather than a form class, so any future form gets
     the behaviour by marking its error block and nothing else. */
  function initFormErrorFocus() {
    var errors = document.querySelector('[data-form-errors]');
    if (!errors) return;
    errors.focus();
    errors.scrollIntoView({ block: 'center' });
  }

  /* Motif field parallax — the cloth behind a product grid drifts up more
     slowly than the cards, so it never catches them.

     Factor 0.35 means the field travels a third of the distance the grid does.
     The write is a CSS custom property rather than a style.transform, so the
     rotation keyframe on the child is untouched: the two motions live on two
     elements precisely so neither has to know about the other.

     Cost control, because this runs on a 40-page collection:
     - Only fields currently intersecting the viewport are in `live`.
     - One rAF per scroll burst, never one per event.
     - Fields off screen have their rotation paused by CSS (.is-live).
     - Reduced motion exits before any observer is created, so the stars render
       once, statically, and nothing listens to scroll at all. */
  function initMotifFields() {
    var fields = document.querySelectorAll('[data-motif-field]');
    if (!fields.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var live = [];
    var ticking = false;

    var io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        var el = entries[i].target;
        var at = live.indexOf(el);
        if (entries[i].isIntersecting) {
          el.classList.add('is-live');
          if (at < 0) live.push(el);
        } else {
          el.classList.remove('is-live');
          if (at >= 0) live.splice(at, 1);
        }
      }
      if (live.length) request();
    }, { rootMargin: '120px 0px' });

    for (var f = 0; f < fields.length; f++) io.observe(fields[f]);

    function paint() {
      ticking = false;
      var vh = window.innerHeight;
      for (var i = 0; i < live.length; i++) {
        var el = live[i];
        var r = el.getBoundingClientRect();
        /* Zero when the field's centre is at the viewport's centre, so the
           offset grows in both directions from a natural rest point rather
           than accumulating with absolute page position. */
        var delta = (vh / 2) - (r.top + r.height / 2);
        el.style.setProperty('--mf-py', (delta * 0.35).toFixed(1) + 'px');
      }
    }

    function request() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(paint);
    }

    window.addEventListener('scroll', request, { passive: true });
    window.addEventListener('resize', request, { passive: true });
    request();
  }

  /* Footer link columns: collapsed on phones, always open above 720px.

     The markup ships `open` so a visitor without JavaScript gets today's
     footer - long, but every link present and reachable. This closes the
     groups only where the height actually hurts, and re-opens them if the
     viewport grows past the breakpoint, so a rotation never leaves a desktop
     layout with three collapsed columns in it.

     `userToggled` is the reason this is not a one-liner. Once someone has
     opened or closed a group by hand, a later resize must not overrule them.
     Rotating a phone should not slam shut the list they just opened to read. */
  function initFooterAccordions() {
    var accs = document.querySelectorAll('.site-footer .foot-acc');
    if (!accs.length) return;
    var narrow = window.matchMedia('(max-width: 720px)');
    var userToggled = false;
    var wantOpen = null;

    /* A plain "applying" flag does not work here: the `toggle` event is queued
       as a task, so it arrives after any synchronous flag has been cleared and
       every programmatic change would look like a user action. Comparing the
       element's state against the state we last asked for is timing-proof. */
    for (var i = 0; i < accs.length; i++) {
      accs[i].addEventListener('toggle', function (e) {
        if (e.target.open !== wantOpen) userToggled = true;
      });
    }

    function apply() {
      if (userToggled) return;
      wantOpen = !narrow.matches;
      for (var j = 0; j < accs.length; j++) {
        if (wantOpen) accs[j].setAttribute('open', '');
        else accs[j].removeAttribute('open');
      }
    }
    apply();

    /* addEventListener('change') is the modern form; addListener is kept for
       older WebKit, which is exactly the population this theme cares about. */
    if (narrow.addEventListener) narrow.addEventListener('change', apply);
    else if (narrow.addListener) narrow.addListener(apply);
  }

  /* Announcement bar: cross-fade between messages.

     Liquid already marked message one current, so this function's only job is
     to move that class along. With JavaScript off, or with fewer than two
     messages, the bar is a static line and nothing here runs. */
  function initAnnounceRotator() {
    var bar = document.querySelector('[data-announce]');
    if (!bar) return;
    var items = bar.querySelectorAll('.ann-item');
    if (items.length < 2) return;

    /* A message can be hidden on phones (Show on mobile off in the block
       settings). The rotation has to step OVER those: cycling by index alone
       would leave the bar empty for every hidden message. Visibility is read
       per tick rather than cached, so rotating the device is handled without a
       resize listener. */
    function shown(el) { return getComputedStyle(el).display !== 'none'; }
    function visibleCount() {
      var n = 0;
      for (var i = 0; i < items.length; i++) if (shown(items[i])) n++;
      return n;
    }
    function nextVisible(from) {
      for (var i = 1; i <= items.length; i++) {
        var j = (from + i) % items.length;
        if (shown(items[j])) return j;
      }
      return from;
    }

    /* Auto-updating text is a comprehension problem before it is a motion
       problem: removing only the fade would still swap the sentence out from
       under someone mid-read. So reduced motion stops the rotation outright
       and leaves message one, which is what the bar was before this existed. */
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var period = parseInt(bar.getAttribute('data-announce-seconds'), 10);
    if (!period || period < 3) period = 5;
    period *= 1000;

    var at = 0;
    var timer = null;
    var held = false;

    function show(n) {
      items[at].classList.remove('is-current');
      at = (n + items.length) % items.length;
      items[at].classList.add('is-current');
    }
    /* Only rotate when there is something to rotate between. With one visible
       message the bar is static, which is the correct behaviour, not a bug. */
    function start() {
      if (!timer && !held && visibleCount() > 1) {
        timer = setInterval(function () { show(nextVisible(at)); }, period);
      }
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function hold(on) { held = on; if (on) stop(); else start(); }

    /* Pause while someone is reading or tabbing through the bar. The
       relatedTarget check keeps focus moving between the bar's own children
       from counting as leaving it. */
    bar.addEventListener('mouseenter', function () { hold(true); });
    bar.addEventListener('mouseleave', function () { hold(false); });
    bar.addEventListener('focusin', function () { hold(true); });
    bar.addEventListener('focusout', function (e) {
      if (!bar.contains(e.relatedTarget)) hold(false);
    });

    /* A backgrounded tab would otherwise return having cycled through every
       message with nobody watching. */
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop(); else start();
    });

    /* Theme editor: selecting a message must show that message, not whichever
       one the timer happens to have landed on. */
    document.addEventListener('shopify:block:select', function (e) {
      for (var k = 0; k < items.length; k++) {
        if (items[k] === e.target || items[k].contains(e.target)) {
          hold(true);
          show(k);
          return;
        }
      }
    });
    document.addEventListener('shopify:block:deselect', function () { hold(false); });

    /* Liquid marks the FIRST block is-current. If that one is desktop-only the
       phone would open on an empty bar, so move to the first visible message
       before the timer starts. */
    if (!shown(items[at])) show(nextVisible(at));

    start();
  }

  /* On load: mark wishlisted items already in storage, sync the header badge, wire the PDP.
     Each init exits silently when its markup is absent. */
  /* ---- TikTok commerce events -------------------------------------------
     theme.liquid installs TikTok's base pixel, which fires Pageview and stops
     there. ViewContent, AddToCart and InitiateCheckout have to be sent by
     hand, and these are those calls.

     CompletePayment (Purchase) is deliberately absent. Shopify's checkout and
     thank-you pages do not render theme.liquid, so no code in this file can
     ever reach them. That event belongs in a Custom Pixel under
     Settings > Customer events.

     Every call is wrapped in a try/catch and guarded on ttq existing. The
     pixel is a third party that can be blocked, slow, or absent entirely, and
     none of those may take the storefront down with it. Listeners run in the
     capture phase so the event is queued before the form navigates away. */
  function ttTrack(name, params) {
    try {
      if (window.ttq && typeof window.ttq.track === 'function') window.ttq.track(name, params);
    } catch (e) {}
  }
  function ttNum(v) { var n = parseFloat(v); return isFinite(n) ? n : 0; }

  function ttViewContent() {
    var el = document.querySelector('[data-tt-view]');
    if (!el) return;
    ttTrack('ViewContent', {
      contents: [{
        content_id: el.getAttribute('data-tt-id') || '',
        content_type: 'product',
        content_name: el.getAttribute('data-tt-name') || ''
      }],
      value: ttNum(el.getAttribute('data-tt-price')),
      currency: el.getAttribute('data-tt-currency') || 'USD'
    });
  }

  function ttAddToCart(form) {
    var el = form.querySelector('[data-tt-product]');
    if (!el) return;
    var idInput = form.querySelector('input[name="id"]');
    var vid = String(idInput && idInput.value ? idInput.value : el.getAttribute('data-tt-id') || '');
    var qtyInput = form.querySelector('input[name="quantity"]');
    var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;

    /* Price follows the variant actually selected, not the one the page
       rendered with — see the note in main-product.liquid. */
    var price = ttNum(el.getAttribute('data-tt-price'));
    var map = el.getAttribute('data-tt-prices');
    if (map) {
      try { var m = JSON.parse(map); if (m[vid] != null) price = ttNum(m[vid]); } catch (e) {}
    }
    ttTrack('AddToCart', {
      contents: [{
        content_id: vid,
        content_type: 'product',
        content_name: el.getAttribute('data-tt-name') || '',
        quantity: qty,
        price: price
      }],
      value: price * qty,
      currency: el.getAttribute('data-tt-currency') || 'USD'
    });
  }

  function ttInitiateCheckout(btn) {
    var raw = btn.getAttribute('data-tt-cart');
    if (!raw) return;
    var d;
    try { d = JSON.parse(raw); } catch (e) { return; }
    ttTrack('InitiateCheckout', {
      contents: d.contents || [],
      value: ttNum(d.value),
      currency: d.currency || 'USD'
    });
  }

  /* One polite status region for in-place confirmations (quick add, clear cart). */
  var statusEl = null;
  function announce(msg) {
    if (!statusEl) {
      statusEl = document.createElement('div');
      statusEl.className = 'visually-hidden';
      statusEl.setAttribute('role', 'status');
      document.body.appendChild(statusEl);
    }
    statusEl.textContent = '';
    setTimeout(function () { statusEl.textContent = msg; }, 50);
  }

  /* Quick add on product cards (2026-10-08). The card form used to post and land
     on /cart, which pulled the shopper out of the grid they were browsing. Now it
     adds in place: the button confirms, the header count ticks up, and screen
     readers hear it. The product page's own form is not a card and still goes to
     the cart. Any failure (sold out meanwhile, quantity cap) falls back to the
     plain submit, so the cart page explains what happened. */
  function bumpCartBadges(count) {
    var badges = document.querySelectorAll('.count-badge:not(.wish-badge)');
    var still = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    for (var i = 0; i < badges.length; i++) {
      badges[i].setAttribute('data-n', count);
      badges[i].textContent = count;
      if (!still && badges[i].animate) {
        badges[i].animate(
          [{ transform: 'scale(1)' }, { transform: 'scale(1.45)' }, { transform: 'scale(1)' }],
          { duration: 420, easing: 'cubic-bezier(.22,1,.36,1)' }
        );
      }
    }
  }
  function initQuickAdd() {
    if (!window.fetch) return;
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.closest || !form.closest('.card .quick')) return;
      var btn = form.querySelector('button[type="submit"]');
      if (!btn) return;
      e.preventDefault();
      if (btn.getAttribute('aria-busy') === 'true' || btn.classList.contains('is-added')) return;
      var label = btn.textContent.trim();
      var added = btn.getAttribute('data-added') || label;
      var tt = form.querySelector('[data-tt-product]');
      var name = tt ? tt.getAttribute('data-tt-name') : '';
      btn.setAttribute('aria-busy', 'true');
      btn.classList.add('is-adding');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form)
      })
        .then(function (r) { if (!r.ok) throw 0; return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }); })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          btn.removeAttribute('aria-busy');
          btn.classList.remove('is-adding');
          btn.classList.add('is-added');
          btn.innerHTML = '<svg class="quick-check" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>' + wlEsc(added);
          bumpCartBadges(c.item_count);
          announce(name ? name + ': ' + added : added);
          setTimeout(function () {
            btn.classList.remove('is-added');
            btn.textContent = label;
          }, 1800);
        })
        .catch(function () {
          btn.removeAttribute('aria-busy');
          btn.classList.remove('is-adding');
          form.submit();
        });
    });
  }

  /* Clear cart (2026-10-08). The button posts a separate form to /cart/clear, so
     it works without JS. With JS it asks for a second tap first: emptying a cart
     cannot be undone, and a stray tap next to Remove should not cost the order. */
  function initCartClear() {
    var btn = document.querySelector('[data-cart-clear]');
    if (!btn) return;
    var label = btn.textContent.trim(), timer = null;
    btn.addEventListener('click', function (e) {
      if (btn.classList.contains('is-armed')) {
        clearTimeout(timer);
        btn.setAttribute('aria-busy', 'true');
        return;
      }
      e.preventDefault();
      btn.classList.add('is-armed');
      btn.textContent = btn.getAttribute('data-confirm') || label;
      announce(btn.textContent);
      timer = setTimeout(function () {
        btn.classList.remove('is-armed');
        btn.textContent = label;
      }, 4000);
    });
  }

  function initTikTokEvents() {
    ttViewContent();
    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (f && f.querySelector && f.querySelector('[data-tt-product]')) ttAddToCart(f);
    }, true);
    document.addEventListener('click', function (e) {
      var b = e.target && e.target.closest ? e.target.closest('[data-tt-checkout]') : null;
      if (b) ttInitiateCheckout(b);
    }, true);
  }

  /* Stretch the cloth band over the run of sections marked data-cloth-member.

     A ground painted per section is a separate cloth per section: each restarts
     its texture tile at its own top edge and each clips its own star field, so
     three sections painting the same cream still read as three. The band is one
     element under all of them, so there is one texture phase and one field.

     Measured against <main>'s own box rather than the viewport, because the band
     is absolutely positioned inside it and offsetTop would be wrong the moment
     anything above main changes height (the announcement bar rotates, and on a
     phone it wraps to two lines).

     Re-measured on resize and whenever a section changes size — the craft grid
     reflows from four columns to two, which moves the bottom of the run by
     hundreds of pixels. ResizeObserver rather than a scroll listener: the run's
     height changes with layout, never with scroll position. */
  function initClothBand() {
    var band = document.querySelector('[data-cloth-band]');
    if (!band) return;
    var members = document.querySelectorAll('[data-cloth-member]');
    if (!members.length) return;
    var main = band.parentElement;

    function place() {
      var mainTop = main.getBoundingClientRect().top + window.pageYOffset;
      var top = Infinity;
      var bottom = -Infinity;
      for (var i = 0; i < members.length; i++) {
        var r = members[i].getBoundingClientRect();
        var t = r.top + window.pageYOffset;
        if (t < top) top = t;
        if (t + r.height > bottom) bottom = t + r.height;
      }
      if (!isFinite(top) || bottom <= top) return;
      band.style.top = (top - mainTop) + 'px';
      band.style.height = (bottom - top) + 'px';
      band.hidden = false;
    }

    place();
    /* Fonts and lazy images land after DOMContentLoaded and both move the run. */
    window.addEventListener('load', place);
    window.addEventListener('resize', place);
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(place);
      for (var m = 0; m < members.length; m++) ro.observe(members[m]);
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    initTikTokEvents();
    initQuickAdd();      /* after initTikTokEvents: its capture listener still sees the submit */
    initCartClear();
    initAnnounceRotator();
    initFooterAccordions();
    initClothBand();     /* before initMotifFields: it owns the band's own field */
    initMotifFields();
    initGallery();
    initPhotoZoom();     /* after initGallery: its thumb listener must swap the src first */
    initVariants();
    initQtyClamp();
    updateWishBadge();
    initWishlistPage();
    initSeamDock();
    initCraftOther();
    initArtisanForm();   /* after initCraftOther, so its change listener exists */
    initFormErrorFocus();/* after initArtisanForm, which restores the saved answers first */
    var wish = readWish();
    if (!wish.length) return;
    var btns = document.querySelectorAll('[data-wish]');
    for (var k = 0; k < btns.length; k++) {
      if (wish.indexOf(btns[k].getAttribute('data-wish')) >= 0) btns[k].classList.add('on');
    }
  });
})();

/* Smart header — locked (always shown) while the hero is in view, hides when
   scrolling down past it, and slides back in on any scroll-up.

   On pages WITHOUT a hero (everywhere except Home) the lock zone is zero, so
   the header hides on the first 6px of downward scroll and returns on any
   scroll-up. That is the intended behaviour, stated honestly — an earlier
   version of this comment claimed a "plain sticky fallback" that the code has
   never implemented, which cost real time during review. */
(function () {
  var header = document.getElementById('hdr');
  if (!header) return;
  var hero = document.querySelector('.hero-split');
  var lastY = window.pageYOffset || document.documentElement.scrollTop || 0;
  var ticking = false;

  function lockZoneBottom() {
    if (!hero) return 0;
    var rect = hero.getBoundingClientRect();
    return rect.top + (window.pageYOffset || 0) + rect.height;
  }

  function update() {
    ticking = false;
    var y = window.pageYOffset || document.documentElement.scrollTop || 0;
    /* iOS rubber-band overscroll reports y values below 0 at the top and past
       the document end at the bottom, in BOTH directions within a single
       bounce — deltas well over the 6px threshold. Reacting to them makes the
       header flicker in and out at the end of every page. Ignore any reading
       outside the real scroll range; the next genuine scroll updates lastY. */
    var maxY = (document.documentElement.scrollHeight - window.innerHeight) || 0;
    if (y < 0 || y > Math.max(0, maxY)) return;
    header.classList.toggle('header-scrolled', y > 4);   // floating-layer shadow once off the top
    var past = y > (lockZoneBottom() - header.offsetHeight);
    if (y <= 0 || !past) {
      header.classList.remove('header-hidden');            // at top or over the hero: locked, always shown
      lastY = y;                                           // keep the reference fresh for leaving the hero
      return;
    }
    // Past the hero: measure movement since the last toggle. lastY only advances once a
    // threshold is crossed, so even a very slow scroll accumulates until it triggers — a
    // per-frame delta check never fires when scrolling slowly.
    var delta = y - lastY;
    if (delta > 6) {                                       // scrolled down enough -> collapse
      header.classList.add('header-hidden');
      lastY = y;
    } else if (delta < -6) {                               // scrolled up enough -> reveal
      header.classList.remove('header-hidden');
      lastY = y;
    }
  }

  window.addEventListener('scroll', function () {
    if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
  }, { passive: true });
  update();
})();

/* ---- Size guide -------------------------------------------------------------
   Delegated from document, so it works for any number of dialogs on a page and
   needs no re-binding when a section is re-rendered by the theme editor.

   showModal() rather than show(): it gives the ::backdrop, the Esc key and focus
   trapping for free. Guarded because a <dialog> already open throws on a second
   showModal() call. */
(function () {
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-sg-open]');
    if (open) {
      var d = document.getElementById(open.getAttribute('data-sg-open'));
      if (d && !d.open) { d.showModal(); }
      return;
    }

    var close = e.target.closest('[data-sg-close]');
    if (close) {
      var dc = close.closest('dialog');
      if (dc) { dc.close(); }
      return;
    }

    var tab = e.target.closest('[data-sg-tab]');
    if (tab) {
      var box = tab.closest('dialog');
      if (!box) { return; }
      var want = tab.getAttribute('data-sg-tab');
      box.querySelectorAll('[data-sg-tab]').forEach(function (t) {
        var on = t === tab;
        t.classList.toggle('is-on', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      box.querySelectorAll('[data-sg-panel]').forEach(function (p) {
        p.classList.toggle('is-hidden', p.getAttribute('data-sg-panel') !== want);
      });
    }
  });

  /* Clicking the backdrop closes it. The dialog's own box is the click target for
     everything inside, so compare against the element itself rather than tracking
     a separate overlay node. */
  document.addEventListener('click', function (e) {
    if (e.target.tagName === 'DIALOG' && e.target.classList.contains('sg')) {
      var r = e.target.getBoundingClientRect();
      var outside = e.clientY < r.top || e.clientY > r.bottom ||
                    e.clientX < r.left || e.clientX > r.right;
      if (outside) { e.target.close(); }
    }
  });
})();
